import React, { useContext } from 'react';
import SearchByDates from './SearchByDates';
import {
    Button,
    Radio,
    RadioGroup,
    FormControlLabel
} from '@material-ui/core';

import SearchByInvoice from './SearchByInvoice';
import theme from '../../../themes/petroff.theme';
import config from '../../../clientConfig';
import { context } from './InvoiceSearchContext';
import { CSVLink } from "react-csv";
import CSVDataGenerator from '../../../utility/CsvDataGenerator';
import { useState, useRef, useEffect } from 'react';
import InvoiceService from '../../../services/WebInvoiceService';
import InvoiceTypeSelector from './InvoiceTypeSelector';
import { InvoiceType } from 'common/constants';

const styles = {
    invoiceSearchWrapper : {
        position : 'sticky',
        top: 0,
        opacity:1.0,
        backgroundColor:'#FAFAFA',
        zIndex: 100,
        paddingBottom : '10px',
    },
    invoiceSearch: {
        margin: '1.25rem auto',
        width: '68%',        
        maxWidth: '90%',
        borderRadius: '6px',
        border: `solid 1px ${theme.palette.common.darkGray}`,
    },
    searchMethod : {
        background: `${theme.palette.common.gray}`,
        display: 'flex',
        justifyContent: 'space-between',
        paddingRight: '1rem',
        borderBottom: `solid 1px ${theme.palette.common.darkGray}`
    },
    invoiceType: {
        border: 'none',
        padding: '0.25rem'
    },
    searchMethodRadio : {
        marginLeft: "1rem",
        display: 'flex',
        flexDirection: 'inherit',
        marginTop: '0',
    },
    searchContainer: {
        display: 'flex',
        flexWrap: 'wrap',
    },
    btn: {
        alignSelf:"center",
        marginRight : "15px",
    },
    exportButton : {
        alignSelf:"center",
        marginRight : "15px",
        textDecoration : "none"
    }
}

function nameForFile(invoiceType) {
    const invoiceTypeString = InvoiceType.plainString(invoiceType).toLowerCase()    
    return config.deployment + `_${invoiceTypeString }_invoices`;
}

export default function SearchForInvoice(props) {
    const invoiceSearchState = useContext(context);
    const [invoicesForExport, setInvoicesForExport] = useState([]);

    const { setUnpaidOnly, 
            setSelected, 
            setIsDateSearch,
            setDeleteInvoiceDialogOpen,
            setFromDate,
            setInvoiceId,
            setToDate,
            fromDate,
            toDate, 
            unpaidOnly,
            isDateSearch,
            invoiceType,
            setInvoiceType } = invoiceSearchState;
    const dateSelected = (invoiceSearchState.selected === 'byDate');
    const csvHeaders = CSVDataGenerator.generateHeaders(invoiceType);
    const csvRef = useRef();

    useEffect(() => {
        if(invoicesForExport.length > 0) {
            csvRef.current.link.click();
        }
    },[invoicesForExport]);

    return (
        <div style={styles.invoiceSearchWrapper}>
            <div style={styles.invoiceSearch}>
                <div style={styles.searchMethod}>
                    <RadioGroup
                        value={invoiceSearchState.selected}
                        style={styles.searchMethodRadio}
                        aria-label="Search Method"
                        onChange={(event) => {
                            setUnpaidOnly(false);
                            setSelected(event.target.value);
                            setIsDateSearch(event.target.value === 'byDate');}}>
                        <FormControlLabel id="byDate" value="byDate" control={<Radio />} label="By Date" />
                        <FormControlLabel id="byInvoice" value="byInvoice" control={<Radio />} label="By Invoice" />
                    </RadioGroup>
                    <InvoiceTypeSelector invoiceTypes={[InvoiceType.TOW, config.isPetroff ? InvoiceType.LOAD : InvoiceType.SHOP]}
                                         onChange={setInvoiceType}/>
                </div>
                <div style={styles.searchContainer}>
                    {dateSelected ?
                        <SearchByDates
                            onFilterChanged={setUnpaidOnly}
                            setFromDate={setFromDate}
                            setToDate={setToDate} /> :
                        <SearchByInvoice
                            setInvoiceId={setInvoiceId} />}
                    {props.canDelete ? <Button
                        style={styles.btn}
                        disabled={!props.deleteEnabled}
                        id='delete-invoice-button'
                        variant='contained'
                        onClick={() => setDeleteInvoiceDialogOpen(true)}
                        color="primary">Delete</Button> : null}
                    <CSVLink
                        style={styles.exportButton} 
                        data={invoicesForExport}
                        headers={csvHeaders}
                        ref={csvRef}
                        filename={nameForFile(invoiceType) + ".csv"}/>
                    {isDateSearch ? <Button
                        id='export-invoices-button' 
                        style={styles.btn}                        
                        onClick={ () => {
                            InvoiceService.searchInvoicesByDate(fromDate, 
                                toDate, 
                                null, 
                                invoiceType, 
                                null, 
                                null, (invoices) => {                
                                    setInvoicesForExport(CSVDataGenerator.generateCSVData(invoices,
                                                                                          unpaidOnly,
                                                                                          invoiceType));                                    
                                });
                            }}
                        variant='contained'>Export
                    </Button>:null}
                </div>
            </div>

        </div>
    );

}
